import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { api, API, assetUrl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { UsersThree, SpinnerGap, SignIn, Check } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function JoinAlbum() {
  const { token } = useParams();
  const nav = useNavigate();
  const { user } = useAuth();
  const [preview, setPreview] = useState(undefined);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/shared-albums/join/${token}`).then((r) => setPreview(r.data)).catch(() => setPreview(null));
  }, [token]);

  const join = async () => {
    if (!user) { nav(`/login?next=${encodeURIComponent(`/join/${token}`)}`); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/shared-albums/join", { token });
      toast.success("You've joined the album");
      nav(`/albums/${data.album_id}`);
    } catch (e) {
      if (e.response?.status === 401) nav(`/login?next=${encodeURIComponent(`/join/${token}`)}`);
      else toast.error(e.response?.data?.detail || "Could not join");
    }
    setBusy(false);
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#FAF8F5] px-5">
      <div className="w-full max-w-md overflow-hidden rounded-3xl border border-[#E5DFD3] bg-white shadow-[0_16px_44px_rgba(44,39,36,0.1)]">
        <div className="brand-sunset h-28 relative">
          {preview?.cover_url && <img src={assetUrl(preview.cover_url)} alt="" className="h-full w-full object-cover" />}
          <div className="absolute inset-0 bg-black/15" />
        </div>
        <div className="p-6 text-center">
          {preview === undefined ? (
            <SpinnerGap size={28} className="mx-auto animate-spin text-[#F27A54]" />
          ) : preview === null ? (
            <>
              <UsersThree size={40} weight="thin" className="mx-auto text-[#D9C9B3]" />
              <p className="mt-2 font-display text-lg font-bold">Invite not found</p>
              <p className="text-sm text-[#787167]">This link is invalid or expired.</p>
            </>
          ) : (
            <>
              <p className="overline text-[10px] text-[#F27A54]">You're invited</p>
              <h1 className="mt-1 font-display text-2xl font-black text-[#2C2724]">{preview.title}</h1>
              <p className="mt-1 text-sm text-[#787167]">by {preview.owner_name} · {preview.member_count} member(s)</p>
              <Button data-testid="join-album-btn" onClick={join} disabled={busy} className="mt-5 h-11 w-full gap-1.5 rounded-full bg-[#F27A54] text-white hover:bg-[#d9633f]">
                {busy ? <SpinnerGap size={16} className="animate-spin" /> : user ? <Check size={16} weight="bold" /> : <SignIn size={16} weight="bold" />}
                {user ? "Join album" : "Sign in to join"}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
